import DropdownNumberMandatory from "./InputComponents/DropdownNumberMandatoryComponent";
import React, { useState, useEffect } from "react";
import CardHeader from "./Utils/CardHeaderComponent";
import DropdownStringMandatory from "./InputComponents/DropdownStringMandatoryComponent";
import TextNoConfidential from "./InputComponents/TextNoConfidentialComponent";
import ConfirmationModal from "./Utils/ConfirmationModal";

interface RDCProps {
    status: number;
    dropdownValues: {
        tab: string;
        inputName: string;
        listValue: string[];
    }[];
    data: {
        name: string;
        ticked: boolean;
        problems: string;
        solutions: string;
        updates: string;
        raisedProblemInECPublicConsultations: string;
        raisedProblemInECPublicConsultationsText: string;
    };
    handleOnChangeRDC: (e: React.ChangeEvent<any>) => void;
    handleDeleteRDC: () => void;
    errors: string[];
}

function RDC({
    data,
    handleOnChangeRDC,
    handleDeleteRDC,
    dropdownValues,
    status,
    errors,
}: RDCProps) {
    const [isHidden, setIsHidden] = useState(true);
    const toggleVisibility = () => {
        setIsHidden((prevState) => !prevState);
    };

    // Add validation for mandatory text fields
    const problemsIsValid = /^.{4,}$/.test(data.problems);
    const solutionsIsValid = /^.{4,}$/.test(data.solutions);
    const updatesIsValid = /^.{4,}$/.test(data.updates);
    const raisedProblemInECPublicConsultationsTextIsValid = /^.{4,}$/.test(
        data.raisedProblemInECPublicConsultationsText
    );

    const [isModalOpen, setIsModalOpen] = useState(false);
    const handleDeleteClick = () => {
        setIsModalOpen(true);
    };
    const confirmDelete = () => {
        setIsModalOpen(false);
        handleDeleteRDC();
    };
    const cancelDelete = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <div className="feedstock-container">
                <CardHeader
                    isHidden={isHidden}
                    toggleVisibility={toggleVisibility}
                    cardName="Regulation"
                    handleDelete={status == 1 ? handleDeleteClick : null}
                    notValid={errors.length > 0}
                />
                {isHidden ? null : (
                    <>
                        <div className="error-container">
                            {errors.map((error, index) => (
                                <div
                                    className="error-text"
                                    key={index}
                                    style={{ marginBottom: "10px" }}
                                >
                                    {error}
                                </div>
                            ))}
                        </div>
                        <DropdownStringMandatory
                            listInputs={
                                dropdownValues.filter((item) => item.inputName == "name")[0]
                                    .listValue
                            }
                            label={"Related initiatives"}
                            inputName={"name"}
                            value={data.name}
                            handleOnChange={handleOnChangeRDC}
                            invalidValues={["-", ""]}
                        />

                        {data.name == "-" ||
                            data.name == "" ||
                            data.name == "N/A" ? null : (
                            <>
                                <TextNoConfidential
                                    label={"Problem(s)"}
                                    textValid={problemsIsValid}
                                    textValue={data.problems}
                                    textName={"problems"}
                                    onChange={handleOnChangeRDC}
                                    display={false}
                                    isMandatory={true}
                                />
                                <TextNoConfidential
                                    label={"Proposed Solution(s)"}
                                    textValid={solutionsIsValid}
                                    textValue={data.solutions}
                                    textName={"solutions"}
                                    onChange={handleOnChangeRDC}
                                    display={false}
                                    isMandatory={true}
                                />

                                <TextNoConfidential
                                    label={
                                        "Please explain if there is any positive or negative evolution in addressing the problem since the last time you reported on it"
                                    }
                                    textValid={updatesIsValid}
                                    textValue={data.updates}
                                    textName={"updates"}
                                    onChange={handleOnChangeRDC}
                                    display={false}
                                    isMandatory={true}
                                />

                                <DropdownStringMandatory
                                    listInputs={["-", "Yes", "No"]}
                                    label={
                                        "Have you already raised the specific problem(s) in an EC Public Consultations?"
                                    }
                                    inputName={"raisedProblemInECPublicConsultations"}
                                    value={data.raisedProblemInECPublicConsultations}
                                    handleOnChange={handleOnChangeRDC}
                                    invalidValues={["", "-"]}
                                />
                                <TextNoConfidential
                                    label={"Please include which public consultation"}
                                    textValid={raisedProblemInECPublicConsultationsTextIsValid}
                                    textValue={data.raisedProblemInECPublicConsultationsText}
                                    textName={"raisedProblemInECPublicConsultationsText"}
                                    onChange={handleOnChangeRDC}
                                    display={data.raisedProblemInECPublicConsultations != "Yes"}
                                    isMandatory={true}
                                />
                            </>
                        )}
                    </>
                )}
            </div>
            <ConfirmationModal
                isOpen={isModalOpen}
                onRequestClose={cancelDelete}
                onConfirm={confirmDelete}
                title="
        Confirm deletion"
                message="Are you sure you want to delete this component ?"
            />
        </>
    );
}

export default RDC;